// extracted by mini-css-extract-plugin
export default {"btn":"JournalRecommender_btn__FlzyD","rounded":"JournalRecommender_rounded__CQg4r","roundCheckbox":"JournalRecommender_roundCheckbox__QFhE7"};